import '../../stylesheets/bookings.css';

import React from 'react';
import { Col, Container, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import { getMyBookings } from '../../actions/bookings';
import BookingList from './BookingList';

const i18nPrefix = 'MaintainBookings';

class Bookings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      activeBookings: [],
      expiredBookings: [],
    };
  }

  componentDidMount() {
    this.fetchBookings();
  }

  fetchBookings = () => {
    this.setState({ loading: true }, () => {
      getMyBookings(
        (response) => {
          const activeBookings = response?.bookings || [];
          const expiredBookings = response?.bookings_old || [];
          this.setState({
            loading: false,
            activeBookings,
            expiredBookings,
          });
        },
        () => {
          this.setState({
            loading: false,
            activeBookings: [],
            expiredBookings: [],
          });
        },
      );
    });
  };

  render() {
    const { t } = this.props;
    const { headerPaddings = {} } = this.props;
    const headerPaddingStyle = {
      paddingTop: headerPaddings.top || 0,
      paddingRight: headerPaddings.right || 0,
      paddingBottom: headerPaddings.bottom || 0,
      paddingLeft: headerPaddings.left || 0,
    };

    return (
      <div className='bookings'>
        <Container>
          <div className='bookings__header' style={headerPaddingStyle}>
            <h4 className='bookings__title'>
              {t(`${i18nPrefix}.title`, 'My bookings')}
            </h4>
          </div>
        {this.state.loading && (
          <Row>
            <Col md={12}>
              <Spinner
                style={{ width: 20, height: 20, marginLeft: 10 }}
                animation='border'
                variant='secondary'
                role='status'
              />
            </Col>
          </Row>
        )}
        <Tabs id='bookings-tabs' defaultActiveKey='active' className='mb-3'>
          <Tab eventKey='active' title={t(`${i18nPrefix}.active`, 'Active')}>
            <BookingList active data={this.state.activeBookings} />
          </Tab>
          <Tab eventKey='expired' title={t(`${i18nPrefix}.expired`, 'Expired')}>
            <BookingList data={this.state.expiredBookings} />
          </Tab>
        </Tabs>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Bookings);
